<template>
	<UiElement class="page" :settings="appearance.body.settings">
		<UiElement
			class="d-flex flex-column align-items-center"
			:settings="elements?.card1?.settings"
		>
			<UiText :settings="heading1">
				{{ translations?.orderHere || '{orderHere}' }}
			</UiText>

			<UiElement :settings="elements?.spacer1?.settings" />

			<router-link :to="`/${route.params.kioskId}/products`" class="w-100 text-decoration-none">
				<UiButton
					:settings="button1"
					class="w-100"
				>
					{{ translations?.toBill || '{toBill}' }}
				</UiButton>
			</router-link>

			<UiElement :settings="elements?.spacer1?.settings" />

			<router-link :to="`/${route.params.kioskId}/products`" class="w-100 text-decoration-none">
				<UiButton :settings="button2" class="w-100">
					{{ translations?.toTakeAway || '{toTakeAway}' }}
				</UiButton>
			</router-link>
		</UiElement>
	</UiElement>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useInheritedSettings } from '@/composables/useInheritedSettings';
import { useThemeStore } from '@/stores/useThemeStore';
import UiElement from '@/components/UI/UiElement.vue';
import UiText from '@/components/UI/UiText.vue';
import UiButton from '@/components/UI/UiButton.vue';
import { useTranslationsStore } from '@/stores/useTranslationsStore';

const route = useRoute();
const themeStore = useThemeStore();
const translationsStore = useTranslationsStore();
const { theme } = storeToRefs(themeStore);

const { translations } = storeToRefs(translationsStore);

const appearance = computed(() => theme.value.pages.start.appearance);
const elements = computed(() => theme.value.pages.start.elements);

const button1 = useInheritedSettings(computed(() => elements.value?.button1));
const button2 = useInheritedSettings(computed(() => elements.value?.button2));
const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
</script>